/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */
export const SET_SHOW_PRELOADER = "SET_SHOW_PRELOADER";
export const SET_PERCENT_PROGRESS = "SET_PERCENT_PROGRESS";
